/*! Modal scroll lock — v4 (no-bounce, no-smooth) */
(() => {
  const state = { locks: 0, y: 0, prevBehavior: '' };

  const root = document.documentElement;

  function scrollbarWidth() {
    return Math.max(0, window.innerWidth - root.clientWidth);
  }

  function lock() {
    state.locks++;
    if (state.locks > 1) return;

    state.y = window.scrollY || window.pageYOffset || 0;

    const sw = scrollbarWidth();
    if (sw) document.body.style.paddingRight = sw + 'px';

    // Disable smooth scroll while locked/unlocked
    state.prevBehavior = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';

    document.body.classList.add('overflow-hidden');
    document.body.style.position = 'fixed';
    document.body.style.top = `-${state.y}px`;
    document.body.style.width = '100%';
  }

  function unlock() {
    if (state.locks === 0) return;
    state.locks--;
    if (state.locks > 0) return;

    const y = state.y;

    // Clear fixed positioning, then restore scroll on the next frames
    document.body.classList.remove('overflow-hidden');
    document.body.style.position = '';
    document.body.style.width = '';
    document.body.style.paddingRight = '';

    requestAnimationFrame(() => {
      // clear top after layout settles
      document.body.style.top = '';
      requestAnimationFrame(() => {
        window.scrollTo(0, y);               // instant restore (no smooth)
        // put back the previous scroll behavior
        root.style.scrollBehavior = state.prevBehavior || '';
      });
    });
  }

  // Hook Dawn-style ModalDialog
  function hook() {
    if (!window.ModalDialog || window.ModalDialog.__qw_v4) return;
    const P = window.ModalDialog.prototype;
    const show = P.show, hide = P.hide;
    P.show = function(...a){ lock(); return show.apply(this, a); };
    P.hide = function(...a){ const r = hide.apply(this, a); unlock(); return r; };
    window.ModalDialog.__qw_v4 = true;
  }
  hook();
  document.addEventListener('shopify:section:load', hook);

  // Fallback for themes exposing <quick-add-modal open>
  function hookFallback() {
    document.querySelectorAll('quick-add-modal').forEach(modal => {
      if (modal.__qw_v4) return;
      const mo = new MutationObserver(muts => {
        for (const m of muts) {
          if (m.type === 'attributes' && m.attributeName === 'open') {
            if (modal.hasAttribute('open')) lock(); else unlock();
          }
        }
      });
      mo.observe(modal, { attributes: true });
      modal.__qw_v4 = true;
    });
  }
  hookFallback();
  document.addEventListener('shopify:section:load', hookFallback);

  // Safety: if the page unloads while locked, clean up
  window.addEventListener('pagehide', () => { if (state.locks) unlock(); });
})();
